import React, { useEffect, useState } from 'react';
import { client } from '../../client';

export default function Coins() {
  const [users, setUsers] = useState([]);

  useEffect(() => {
    client.fetch(`*[_type == "user"]{_id, userName, coins}`).then(data => {
      setUsers(data);
    });
  }, []);

  return (
    <div className="w-full max-w-3xl mx-auto">
      <h2 className="text-3xl font-extrabold mb-8 text-white dark:text-white text-center tracking-tight drop-shadow-lg">
        User Coins
      </h2>
      <div className="relative rounded-3xl overflow-hidden shadow-2xl bg-gradient-to-br from-gray-900 via-gray-950 to-slate-900 dark:from-gray-900 dark:via-gray-800 dark:to-slate-900 backdrop-blur-xl border border-blue-400/30 dark:border-blue-400/40 p-0 sm:p-0">
        {/* Gradient border effect */}
        <div className="absolute inset-0 z-0 pointer-events-none rounded-3xl bg-gradient-to-tr from-blue-400 via-teal-400 to-purple-500 opacity-40 blur-[2px]" />
        <div className="relative z-10">
          <table className="w-full rounded-2xl overflow-hidden">
            <thead>
              <tr>
                <th className="p-3 text-left font-semibold text-white bg-gradient-to-r from-blue-600 via-teal-500 to-purple-600 rounded-t-2xl">
                  User Name
                </th>
                <th className="p-3 text-left font-semibold text-white bg-gradient-to-r from-blue-600 via-teal-500 to-purple-600 rounded-t-2xl">
                  Coins
                </th>
              </tr>
            </thead>
            <tbody>
              {users.map((user, idx) => (
                <tr
                  key={user._id}
                  className={`${idx % 2 === 0
                      ? 'bg-gradient-to-r from-gray-900 via-gray-800 to-slate-900'
                      : 'bg-gradient-to-r from-gray-800 via-gray-900 to-slate-900'
                    } hover:bg-blue-900/40 transition-colors`}
                >
                  <td className="p-3 text-white font-medium">{user.userName}</td>
                  <td className="p-3 text-cyan-300 font-bold">{user.coins || 0}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}